<template>
  <div>
    <!-- 自定义分享弹窗 -->
    <transition name="fade">
      <div class="custom-share-popup" v-if="visible" @click.self="handleClose">
        <div class="share-wrapper">
          <div class="share-list">
            <div class="share-item" @click="shareToQzone">
              <img src="@/assets/images/qzone.png" alt="QQ空间" class="share-icon">
              <span class="share-text">分享到QQ空间</span>
            </div>
            <div class="share-item" @click="shareToQQ">
              <img src="@/assets/images/qq.png" alt="QQ" class="share-icon">
              <span class="share-text">分享到QQ</span>
            </div>
            <div class="share-item" @click="shareToWeibo">
              <img src="@/assets/images/weibo.png" alt="微博" class="share-icon">
              <span class="share-text">分享到微博</span>
            </div>
            <div class="share-item" @click="shareToWechat">
              <img src="@/assets/images/wechat.png" alt="微信" class="share-icon">
              <span class="share-text">分享到微信</span>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 微信分享二维码弹窗 -->
    <el-dialog
      :visible.sync="showWechatShareDialog"
      :show-close="true"
      width="350px"
      custom-class="wechat-share-dialog"
      center
    >
      <div class="share-content">
        <h3 class="share-title">请使用微信扫描二维码分享</h3>
        <div id="wechat-share-qrcode" class="qrcode-container"></div>
        <p class="share-tip">请使用微信扫描二维码完成分享</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import sign from '@/auth/sign'
import { share } from '@/axios/education'

export default {
  name: 'ShareDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    shareData: {
      type: Object,
      default: () => ({
        title: '', // 课件标题
        teacherName: '', // 教师姓名
        teacherId: null, // 教师ID
        coverImage: '', // 封面图片
        picUrl: '', // 图片基础URL
        type: 2, // 课件类型：3为付费，其他为免费
        appid: 'wzwebapp', // 应用ID
        url: '' // 分享URL，默认为当前页面URL
      })
    }
  },
  data() {
    return {
      showWechatShareDialog: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close', false)
    },
    // 分享到QQ
    shareToQQ() {
      const title = `万知教育-${this.shareData.teacherName}老师`
      const desc = `${this.shareData.teacherName}老师的${this.shareData.type === 3 ? '付费' : '免费'}视频课件`
      const url = this.shareData.url || window.location.href
      const summary = this.shareData.title
      const pics = this.shareData.coverImage ? this.shareData.picUrl + this.shareData.coverImage : ''

      const shareUrl = `http://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&source=${encodeURIComponent('万知教育')}&desc=${encodeURIComponent(desc)}&pics=${encodeURIComponent(pics)}&summary=${encodeURIComponent(summary)}`

      window.open(shareUrl, '_blank')
      this.doShare()
    },
    // 分享到QQ空间
    shareToQzone() {
      const title = `万知教育-${this.shareData.teacherName}老师`
      const desc = `${this.shareData.teacherName}老师的${this.shareData.type === 3 ? '付费' : '免费'}视频课件`
      const url = this.shareData.url || window.location.href
      const summary = this.shareData.title
      const pics = this.shareData.coverImage ? this.shareData.picUrl + this.shareData.coverImage : ''

      const shareUrl = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&desc=${encodeURIComponent(desc)}&summary=${encodeURIComponent(summary)}&pics=${encodeURIComponent(pics)}`

      window.open(shareUrl, '_blank')
      this.doShare()
    },
    // 分享到微博
    shareToWeibo() {
      const title = `万知教育-${this.shareData.teacherName}老师`
      const url = this.shareData.url || window.location.href
      const pic = this.shareData.coverImage ? this.shareData.picUrl + this.shareData.coverImage : ''

      const shareUrl = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&pic=${encodeURIComponent(pic)}&appkey=`

      window.open(shareUrl, '_blank')
      this.doShare()
    },
    // 分享到微信
    shareToWechat() {
      this.handleClose()
      this.showWechatShareDialog = true
      this.$nextTick(() => {
        const qrcodeContainer = document.getElementById('wechat-share-qrcode')
        if (qrcodeContainer) {
          qrcodeContainer.innerHTML = ''
          const url = this.shareData.url || window.location.href
          // eslint-disable-next-line no-unused-vars
          const qrcode = new QRCode(qrcodeContainer, {
            width: 180,
            height: 180,
            text: url,
            colorDark: '#000',
            colorLight: '#fff',
            correctLevel: QRCode.CorrectLevel.H
          })
        }
      })
    },
    // 记录分享操作
    doShare() {
      if (!this.shareData.teacherId) {
        console.warn('分享失败：缺少教师ID')
        return
      }

      const params = {
        appid: this.shareData.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.shareData.teacherId,
        type: 3
      }
      const signO = sign(params)
      params.sign = signO

      share(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.$message.success('分享成功')
          this.handleClose()
          // 触发分享成功事件
          this.$emit('share-success')
        } else {
          this.$message.error(res.data.msg || '分享失败')
        }
      }).catch(() => {
        this.$message.error('分享失败，请稍后重试')
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 自定义分享弹窗样式 */
.custom-share-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;

  .share-wrapper {
    width: 300px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;

    .share-list {
      .share-item {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        cursor: pointer;
        transition: background-color 0.3s;
        background: #fff;

        &:hover {
          background-color: #f5f7fa;
        }

        .share-icon {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }

        .share-text {
          font-size: 14px;
          color: #333;
        }

        &:not(:last-child) {
          border-bottom: 1px solid #f0f0f0;
        }
      }
    }
  }
}

/* 弹窗动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>

<style lang="less">
/* 微信分享二维码弹窗样式 */
.wechat-share-dialog {
  .share-content {
    text-align: center;

    .share-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }

    .qrcode-container {
      width: 180px;
      height: 180px;
      margin: 0 auto 20px;
      padding: 10px;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      background: #fff;
    }

    .share-tip {
      color: #666;
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/ShareDialog.vue